import { createAction, props } from "@ngrx/store";
import { SensorElement } from "../../models/location-card.model";

export enum TritonActionType {
    TRITON_CHANGE_SENSOR = '@form/TRITON_CHANGE_SENSOR',
    TRITON_CHANGE_CHANNEL = '@form/TRITON_CHANGE_CHANNEL',
    TRITON_CHANGE_MONITOR_POINT = '@form/TRITON_CHANGE_MONITOR_POINT',
    TRITON_COMM_PORT_CHANGE = '@form/TRITON_COMM_PORT_CHANGE',
    TRITON_SET_SILT_VALUE = '@form/TRITON_SET_SILT_VALUE',
    TRITON_SAMPLER_TYPE_CHANGE = '@form/TRITON_SAMPLER_TYPE_CHANGE',
    TRITON_GAIN_CONTROL_CHANGE = '@form/TRITON_GAIN_CONTROL_CHANGE',
}


export const tritonSensorChange = createAction(
    TritonActionType.TRITON_CHANGE_SENSOR,
    props<{ sensor: SensorElement; index: number }>(),
);
export const tritonChannelChange = createAction(TritonActionType.TRITON_CHANGE_CHANNEL, props<{ index: number }>());
export const tritonMonitorPointChange = createAction(TritonActionType.TRITON_CHANGE_MONITOR_POINT, props<{ index: number }>());
export const commportChange = createAction(TritonActionType.TRITON_COMM_PORT_CHANGE, props<{ commport: string }>());
export const setTritonSiltValue = createAction(TritonActionType.TRITON_SET_SILT_VALUE, props<{ mp: number; value: number }>());
export const samplerTypeChange = createAction(TritonActionType.TRITON_SAMPLER_TYPE_CHANGE, props<{ samplingType: number }>());
export const tritonGainControlChange = createAction(TritonActionType.TRITON_GAIN_CONTROL_CHANGE, props<{ isManual: boolean; sensorIndex: 0 | 1 }>());
